export const Constants = {

    CURRENT_EVENT: "62380f4cc51cbe72eb270255",
    IMD_EVENT_ID: "61a58593c2d30d1bfc227766",
    GMC_EVENT_ID: "61e7ef120898f35c01753c24",
    SCIENCE_SUBJECTID: '66a9d14e933e00065a431f08',
    MATHS_SUBJECTID: '66a9d13f933e00065a431f07',
    CLICKER_CONCEPT_CARD : 'CLICKER_CONCEPT_CARD',
    CLICKER_PRACTICE_STANDARD : 'CLICKER_PRACTICE_STANDARD',
    CLICKER_ASSESSMENT : 'CLICKER_ASSESSMENT',
    ONLY_REVISION : 'ONLY_REVISION',
    REVISION_WITH_PRACTICE : 'REVISION_WITH_PRACTICE',
    REVISION_WITH_ASSESSMENT : 'REVISION_WITH_ASSESSMENT',
    CLICKER_CONCEPT_CARD_WITH_ASSESSMENT : 'CLICKER_CONCEPT_CARD_WITH_ASSESSMENT',
    BASIC : '69f8807a1371cd3394c6992e',
    ADVANCED : '69f8807a1371cd3394c6992f',
    MIXED : '69fc072c3b787fe71c50a9f3',

    ANDROID_BUILD : true,

    ELECTRON_BUILD : false,

    ELECTRON_VERSION : "1.9",

    SIGNLE_SELECT: 1,
    MULTI_SELECT: 2,
    FILL_IN_THE_BLANK: 3,
    MATCHING: 4,
    SEQUENCE: 5,
    GROUPING: 6,
    LABELING: 7,
    BINARY: 8,
    GEOMETRY_QUESTION: 10,

    CONTENT_TYPE_TEXT: 1,
    CONTENT_TYPE_IMAGE: 2,
    CONTENT_TYPE_BLANK: 3,
    CONTENT_TYPE_DROP_DOWN: 4,

    DB_NAME: 'simpliDatabse',
    STAFF_STORE: 'staff_store',
    TEACHER_HOMEWORK_ACTIVITY_STORE: 'teacher_homework_activity_store',
    CONTENTS_STORE: 'contents_store',
    USER_ASSESSMENT_ACTIVITY_STORE: 'user_assessment_activity_store',
    CLICKER_USERS_STORE: 'clicker_users_store',
    COOKIE_STORE: 'cookie_store',
    CLICKER_ASSESSMENT_LEADERBOARD: 'clicker_assessment_leaderboard', // Newly added for Quiz Module 
    HOMEWORK_STORE: 'homework_store',

    HOMEWORK_NODES_STORE: 'homework_nodes_store',
    ELO_STORE: 'elo_store',
    CONTENT_META_DATA_STORE: 'content_meta_data_store',
    USER_HOMEWORK_NODE_ACTIVITY_STORE: 'user_homework_node_activity_store',
    USER_HOMEWORK_ELO_ACTIVITY_STORE: 'user_homework_elo_activity_store',



    DB_VERSION: 16,

    STORE_CONFIG: [
        {
            storeName: "staff_store",
            keyPath: "id",
            indexes: [
                { indexName: "email", keyPath: "email" },
                { indexName: "mobileNumber", keyPath: "mobileNumber" }
            ]
        },
        {
            storeName: "teacher_homework_activity_store",
            keyPath: "_id",
            indexes: [
                { indexName: "type", keyPath: "type" },
                { indexName: "schoolId", keyPath: "schoolId" },
                { indexName: "homeworkId", keyPath: "homeworkId" }
            ]
        },
        {
            storeName: "contents_store",
            keyPath: "_id",
            indexes: []
        },
        {
            storeName: "user_assessment_activity_store",
            keyPath: "_id",
            indexes: [
                { indexName: "schoolAssessmentId", keyPath: "schoolAssessmentId" }
            ]
        },
        {
            storeName: "clicker_users_store",
            keyPath: "userId",
            indexes: [
                { indexName: "userId", keyPath: "userId" }
            ]
        },
        {
            storeName: "cookie_store",
            keyPath: "hash",
            indexes: [
                { indexName: "hash", keyPath: "hash" }
            ]
        },
        {
            storeName: "clicker_assessment_leaderboard",
            keyPath: "assessmentActivityId",
            indexes: [
                { indexName: "assessmentActivityId", keyPath: "assessmentActivityId" },
                { indexName: "homeworkId", keyPath: "homeworkId" }
            ]
        },
        {
            storeName: "homework_store",
            keyPath: "_id",
            indexes: [
                { indexName: "type", keyPath: "type" },
                { indexName: "schoolId", keyPath: "schoolId" }
            ]
        },
        {
            storeName: 'homework_nodes_store',
            keyPath: "_id",
            indexes: [
                { indexName: "homeworkId", keyPath: "homeworkId" }
            ]
        },
        {
            storeName: 'elo_store',
            keyPath: "_id",
            indexes: [
            ]
        },
        {
            storeName: 'content_meta_data_store',
            keyPath: "_id",
            indexes: [
                { indexName: "objectId", keyPath: "objectId" },
            ]
        },
        {
            storeName: 'user_homework_node_activity_store',
            keyPath: "userIdNodeIdHomeworkId",
            indexes: [
                { indexName: "userIdNodeIdHomeworkId", keyPath: "userIdNodeIdHomeworkId" },
                { indexName: "userIdHomeworkId", keyPath: "userIdHomeworkId" },
                { indexName: "homeworkId", keyPath: "homeworkId" }
            ]
        },
        {
            storeName: 'user_homework_elo_activity_store',
            keyPath: "userIdNodeIdHomeworkId",
            indexes: [
                { indexName: "userIdNodeIdHomeworkId", keyPath: "userIdNodeIdHomeworkId" },
                { indexName: "userIdHomeworkId", keyPath: "userIdHomeworkId" },
                { indexName: "homeworkId", keyPath: "homeworkId" }
            ]
        }
    ],


    MAX_GRAGE_LIMIT: 5,
    SLOGAN: "Redefining Maths Learning",
    WELCOME: 'Welcome to Countingwell',
    LOGOUT: 'Logout',
    APPROVAL_TEXT: 'You could access the reports once your account is approved by your',
    COUNTINGWELL_ADMIN: 'Countingwell Admin',
    MATHS_DAY_2021_SIGNUP_SLOGAN: 'School Registration for India Maths day, 2021',
    SIGNUP_SLOGAN: "School Registration for India Maths day, 2021",
    IMPORTANT_DATES: "important dates",

    ACTIVE_TAB_SIGN_UP: 1,
    ACTIVE_TAB_LOGIN: 0,

    /** Forgot password flow */
    SEND_EMAIL_PAGE: 1,
    RESET_PASSWORD_PAGE: 2,
    RESET_PASSWORD_SUCCESS_PAGE: 3,

    INVALID_EMAIL_ID: 1500,
    SECTION_DROPDOWN: [
        {
            title: '1',
            value: 1
        },
        {
            title: '2',
            value: 2
        },
        {
            title: '3',
            value: 3
        },
        {
            title: '4',
            value: 4
        },
        {
            title: '5',
            value: 5
        },
        {
            title: '6',
            value: 6
        },
        {
            title: '7',
            value: 7
        },
        {
            title: '8',
            value: 8
        },
        {
            title: '9',
            value: 9
        },
        {
            title: '10',
            value: 10
        },
    ],

    SCHOOL_ONBOARD: {
        TYPES_LIST: [{ title: "CO-ED", value: "CO-ED" }, { title: "Only Boys", value: "BOYS" }, { title: "Only Girls", value: "GIRLS" },],
        MEDIUM_LIST: [{ title: "English", value: "ENGLISH" }, { title: "Hindi", value: "HINDI" }, { title: "Regional", value: "REGIONAL" },],
        FEE_STRUCTURE_LIST: [{ title: "INR 20,000 - INR 59,000", value: "20,000 - 59,000" }, { title: "INR 60,000 - INR 90,000", value: "60,000 - 90,000" }, { title: "INR 90,000+", value: "90,000+" },],
        PLAN_LIST: [{ title: "B2B", value: "B2B" }, { title: "B2B2C", value: "B2B2C" },],
        GENDER_LIST: [{ title: "Mr.", value: "Mr." }, { title: "Mrs.", value: "Mrs." }, { title: "Miss.", value: "Miss." }],
        IMPORT_TYPE_LIST: [{ title: "Add Excel", value: "EXCEL" },]
    },


    PLAN_TYPES: {
        B2B: "B2B",
        B2B2C: "B2B2C"
    },

    SCHOOL_STATUS: {
        ACCEPTED: "ACCEPTED",
        INVITE_SENT: "Invite Sent",
        NOT_ACCEPTED: "Not Accepted"
    },

    SKILLS_COLOR: {
        KNOWLEDGE: "#ECBE6B",
        CALCULATION: "#FF9501",
        MODELLING: "#7A9AFA",
        COMPREHENSION: "#05C5D9"
    },

    TOOLBAR: [
        { name: 'clipboard', items: ['Undo', 'Redo'] },
        { name: 'Basicstyles', groups: ['Basicstyles', 'cleanup'], items: ['Bold', 'Italic', 'underline', 'Strike'] },
        { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi'], items: ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight'] },
    ],

    ALTERNATE_STUDENT_IMAGE: "https://countingwell-doubts-assets-dev.s3.ap-south-1.amazonaws.com/366a7097-1ebe-4fc7-9c02-15eb91b53d49-user%20image.png",

    SCHOOL_ASSESSMENT_DEEPLINK: "https://t2m3p.app.link/idcLs5rNInb",

    STAFF_EXCEL_FORMAT: 'https://docs.google.com/spreadsheets/d/1dOCC7kf0QJoD8VRlccvg6NguHtl8S1Hd5gka9G8h-K4/edit?usp=sharing',
    STUDENT_EXCEL_FORMAT_1: 'https://docs.google.com/spreadsheets/d/1Lx8BLD8pixKUE4oX67TibBCHk5T7EJ7RfeulYC7UXP8/edit?usp=sharing',
    STUDENT_EXCEL_FORMAT_2: "https://docs.google.com/spreadsheets/d/1aDf06gbHlasiEvihpDDyQo_7JDX4vtXSSN5lDkQaKnU/edit?usp=sharing",
    STUDENT_EXCEL_FORMAT_3: 'https://docs.google.com/spreadsheets/d/1Tw7JR4efZ91LddXlnZj_7ETOmnXfQFwFqbUIPiG7eM4/edit?usp=sharing',
    SCHOOLNAME_BULK_EXCEL_FORMAT: 'https://docs.google.com/spreadsheets/d/1Sxkt1QGrNgtU3PagOcu-ddlo3MMfGTcYzAkkMpirkPE/edit?usp=sharing',

    STUDENT_FORM_FILL_SECRET_KEY: "COUNTINGWELL_NIRMAL_RAVI_CASH",
    STUDENT_FORM_FILL_SECRET_MESSAGE: "COUNTINGWELL_CASH_PRICE_CLAIM_RAVI_NIRMAL"
};


export const ImageConstants = {
    MULTI_STEP_IMAGE : 'multi_step_image',
    ANGLE_DOWN_ARROW : 'angle_down_arrow',
    ANGLE_UP_ARROW : 'angle_up_arrow',
    TEACHER_CLICKER_INFO : 'teacher_clicker_info',
    YEELOW_BULLET: 'yellow_bullet',
    GREEN_BULLET: 'green_bullet',
    LIGHT_GREEN_BULLET: 'light_green_bullet',
    ORANGE_BULLET: 'orange_bullet',
    BLUE_BULLET: 'blue_bullet',
    RED_BULLET: 'red_bullet',
    INDIGO_BULLET: 'indigo_bullet',
    LOGOUT_RED : 'logout-red',
    COPY_ICON : 'copy-icon',
    CLICKER_HAND_ICON : 'clicker-hand-icon',
    COUNTRY_CLOSE_ICON : 'country-close-icon',
    COUNTRY_CODE_SEARCH_ICON : 'country-code-search-icon',
    COUNTRY_DROPDWON_HEADER : 'country-dropdown-header',
     COUNTRY_DROPDWON_FOOTER : 'country-dropdown-footer',
    COUNTRY_CODE_DOWN_ARROW : 'country-code-down-arrow',
    COUNTRY_CODE_SEPARATOR : 'country-code-separator',
    PDF_DOWNLOAD_ICON : 'pdf_download_icon',
    DESKTOP_ICON : 'desktop_icon',
    STUDENT_EXCERSIZE_IMAGE: 'student_excersize_image',
    GREAT_JOB_IMAGE : 'great_job_image',
    FEEDBACK_1:"feedback_1",
    FEEDBACK_2:"feedback_2",
    FEEDBACK_3:"feedback_3",
    THEME_CLOSE_ICON: 'theme_close_icon',
    EXPAND:'expand',
    INCREASED_ICON : 'increased_icon',
    EQUAL_ICON : 'equal_icon',
    NEW_BLACK_TICK_ICON : 'new_black_tick_icon',
    NEW_BLACK_CLOCK_ICON : 'new_black_clock_icon',
    NEXT_ICON : 'next_icon',
    BACK_ICON_ORANGE : 'back_icon',
    BLUE_RIGHT_ICON : 'blue_right_icon',
    BLUE_LEFT_ICON : 'blue_left_icon',
    QUESTION_BLUR : 'question_blur',
    TIMER_PAUSED : 'timer_paused',
    QUESTION_COUNT_DOWN : 'question_countdown',
    RANK_ONE : 'rank_one',
    RANK_TWO : 'rank_two',
    RANK_THREE : 'rank_three',
    RANK_OTHERS : 'rank_others',
    BLUE_FLAG_ICON : 'flag_icon_blue',
    WHITE_TICK_ICON : 'white_tick_icon',
    TRANSPARENT_IMAGE : 'transparent_image',
    GREEN_LEFT_ICON : 'green_left_icon',
    GREEN_RIGHT_ICON : 'green_right_icon',
    CLICKER_ICON : 'clicker_icon',
    CLOSE_ICON_BLOCK_CROSS : 'close_icon_block_cross',
    DOWNLOAD_ICON_WHITE : 'download_icon_white',
    LEADER_BOARD_BLOCK : 'leader_board_block',
    WHITE_QUESTION_MARK : 'white_question_mark',
    WHITE_TIMER_ICON : 'white_timer_icon',
    HANBARGUR_NEW : 'hambargur_new',
    LEADER_BOARD_ICON : 'leader_board_icon',
    GRAY_CHECK_BOX : 'gray_check_box',
    BLOCK_TIMER : 'block_timer',
    GREEN_CHECK_BOX : 'green_check_box',
    WHITE_CHECK_BOX : 'white_check_box',
    YELLOW_BULB : 'yellow_bulb',
    CLASS_ASSIGNMENT : 'class_assignment',
    TEACHER_ASSIGNMENT : 'teacher_assignment',
    CLASS_ASSIGNMENT_DETAILS : 'class_assignment_details',
    TEACHER_ASSIGNMENT_DETAILS : 'teacher_assignment_details',
    CHAPTER_COMPLETED_GIF : 'chapter-completed-gif',
    PRACTICE_QUESTION_DIVIDER : 'practice_question_divider',
    RED_BG_TICK_MARK: 'red_bg_tick_mark',
    PAUSE_BUTTON: 'pause_button',
    LC_BLUR: 'lc_blur',
    BULB_IMAGE: 'bulb_image',
    VERTICAL_LINE: 'vertical_line',
    CLOCK_IMAGE: 'clock_image',
    EXAM_PAD_ICON_BLOCK: 'exam_pad_icon_block',
    QUESTION_MARK: 'question_mark',
    PRACTICE_QUESTION_HEADER_DIVIDER: 'practice_question_header_divider',
    CLOCK_ICON_GRAY: 'clock_icon_gray',
    EXAM_PAD_ICON_GRAY: 'exam_pad_icon_gray',
    DATE_ICON: 'date_icon',
    QUESTION_MARK_ICON: 'question_mark_icon',
    RIGHT_ARROW_ORGANGE: 'right_arrow_orange',
    LEFT_ARROW_ORGANGE: 'left_arrow_orange',
    ASSESSMENT_FOOTER_IMAGE: 'assessment_footer_image',
    TITLE_DIVIDER: 'title-divider',
    HEADER_BG_IMAGE: 'header_bg_image',
    HOMEWORK_CARD_FOOTER: 'homework_card_footer',
    GREEN_BG_TICK_MARK: 'green_bg_tick_mark',
    RED_BG_CROSS_MARK: 'red_bg_cross_mark',
    BLACK_STUDENTS_COUNT_IMAGE: 'black_students_count_image',
    WHITE_STUDENTS_COUNT_IMAGE: 'white_students_count_image',
    CIRCLE_UP_ARROW: 'circle_up_arrow',
    CIRCLE_DOWN_ARROW: 'circle_down_arrow',
    BLACK_SUITCASE_ICON: 'black_suitcase_icon',
    WHITE_SUITCASE_ICON: 'white_suit_case_icon',
    BLUE_SUITCASE_ICON: 'blue-suit-case-icon',
    BLUE_MENU_ICON: 'blue-menu-icon',
    RED_STUDENT_ICON: 'red-student-icon',
    GREEN_CIRCLE_ICON: 'green-circle-icon',
    NO_WORKSHEET_IMAGE: 'no_worksheet_image',
    SHARE_ICON_BLACK: 'share_icon_black',
    VIDEO_PLAY_ICON_NEW: 'video_play_icon_new',
    SHARE_ICON: 'share_icon',
    EXPORT_TO_EXCEL: 'export_to_excel_icon',
    PEN_EDIT_ICON: 'pen_edit_icon',
    STUDENT_IMAGE: 'student_image',
    FILTER_HEADER: 'filter_header',
    FILTER_FOOTER: 'filter_footer',
    GREEN_TICK_ICON: "green_tick_icon",
    FILTER_ICON_NEW: "filter_icon_new",
    FILTER_ICON_ACTIVE: "filter_icon_active",
    IN_PROGRESS_ICON: 'in_progress_icon',
    SEARCH_ICON: "search_icon",
    FILTER_ICON: 'filter_icon',
    DICTIONARY_IMAGE: 'dictionary_image',
    COMPLETION_DETAIL_REPORT: "completion_detail_report",
    EVALUATION_DETAIL_REPORT: "evaluation_detail_report",
    WRONG_QUESTIONS_DETAIL_REPORT: "wrong_questions_detail_report",
    ALL_QUESTIONS_DETAIL_REPORT: "all_questions_detail_report",
    WHITE_DOWN_ANGLE_ARROW: 'white_down_angle_arrow',
    IMD_LOGO_2O23: 'imd_logo_2023',
    WHITE_UP_ANGLE_ARROW: 'white_up_angle_arrow',
    OPTION_SEPARATOR: 'option_separator',
    TICK_MARK_ICON: 'tick_mark_icon',
    NEW_ASSESSMENT_BANNER: "new-assessment-banner",
    TICK_WHITE: "tick-white",
    GRID_ICN: "grid-icn",
    TREE_ICN: "tree-icn",
    MAIL: "mail",
    ONBOARDED: "onboarded",
    INVITE_SENT: "invite-sent",
    ONBOARDED_NEW: "onboarded-new",
    INVITE_SENT_NEW: "invite-sent-new",
    ARROW_UP_ANGLE: "arrow_up_angle",
    ARROW_DOWN_ANGLE: "arrow_down_angle",
    WHITE_VIDEO_ICON: "white_video_icon",
    WHITE_DOWNLOAD_ICON: 'white_download_icon',
    BLACK_DOWNLOAD_ICON: 'black_download_icon',
    LIST_DIVIER: 'list_divider',
    CASE_STUDY_DOWNLOAD_ICON: 'case_study_download_icon',
    ASSIGN_CLASSWORK: 'assign_classwork',
    VIEW_CLASSWORK: 'view_classwork',
    ASSIGN_HOMEWORK: 'assing_homework_new',
    VIEW_HOMEWORK: 'view_homework_new',
    VIDEO_POSTER: 'video_poster',
    DOWNLOAD_ICON_BLUE_BG: 'download_icon_blue_bg',
    PLAY_ICON_GREEN_BG: 'play_icon_green_bg',
    BOOK_WITH_APPLE: 'book_with_apple',
    HOMEWORK_DIVIDER: 'homework_divider',
    INFO_BLUE: 'info_blue',
    PK_POLYGON: 'pk_polygon',
    VIDEO_PLAY_ICON: 'video_play_icon',
    BLUE_DIMOND_ICON: 'blue_dimond_icon',
    GREEN_ECLIPSE_ICON: 'green_eclipse_icon',
    BLUE_BOOK_ICON: 'blue_book_icon',
    GRAY_CENTER_DIVIDER: 'gray_center_divider',
    PLAY_ICON_BLUE_BG: 'play_icon_blue_bg',
    SOLVED_EXAMPLE_ICON: 'solved_example_icon',
    SOLVED_EXAMPLE_ECLIPSE: 'solved_example_eclipse',
    SOLVED_EXAMPLE_BOOK_ICON: 'solved_example_book_icon',
    PLAY_ICON_ORANGE: 'play_icon_orange',
    VIDEO_DETAIL_HEADER_IMAGE: 'video_detail_header_image',
    VIDEO_DETAIL_POLYGON: 'video_detail_polygon',
    ALL_VIDEO_ECLIPSE: 'all_video_eclipse',
    ALL_VIDEO_POLYGON: 'all_video_polygon',
    CASE_STUDY_BG: 'case_study_bg',
    CASE_STUDY_ICON: 'case_study_icon',
    VIEW_MORE_IMAGE: 'view_more_image',
    CHAPTER_ACTIVITY_ICON: 'chapter_activity_icon',
    ACTIVITY_BG: 'activity_bg',
    CASE_STUDY_QUESTION_ICON: 'case_study_question_icon',
    CASE_STUDY_QUESTION_BG: 'case_study_question_bg',
    ACTIVITY_QUESTION_ICON: 'activity_question_icon',
    ACTIVITY_QUESTION_BG: 'activity_question_bg',
    GREEN_TICK_MARK: 'green_tick_mark',
    EXAM_PAD_ICON: 'exam_pad_icon',
    HOMEWORK_EVALUATION: 'homework_evaluation',
    RECOMMENDATION_REPORT: 'recommendation_report',
    ALL_QUESTIONS: 'all_questions',
    WRONG_QUESTIONS: 'wrong_questions',
    BULB_BLUE: 'bulb_blue',
    RECOMMENDATION_REPORT_CIRCLE: 'recommendation_report_circle',
    RECOMMENDED_ACTION: 'recommended_action',
    MEN_BULB_BLUE: 'men_bulb_blue',
    Q_A_CIRCLE: 'q_a_circle',
    GREEN_DOWNLOAD_ICON: 'green_download_icon',
    SCHOOL_PORTAL_MSF_BANNER: 'school_portal_msf_banner',
    ELLIPSE_BLUE: 'ellipse_blue',
    Q_A_ORANGE: 'q_a_orange',
    NMD_POSTER: 'nmd2023',

    WHITE_TICK_MARK: "white_tick_mark",
    EYE_ICON: "eye_icon",
    CIRCLE_INFO_ICON: "circle_info_icon",

    VIDEO_ICON: "video_icon",
    BOOK_ICON: "book_icon",
    WHITE_CLOSE_ICON: "white_close_icon",


    CW_LOGO_NEW: "cw_logo_new",

    STEM_QUESTION_EXAMPLE: "stem-question-example",
    TREE_LINE_ICN_BLACK: "tree-line-icn-balck",
    TREE_LINE_ICN: "tree-line-icn",
    TREE_LINE_SINGLE_ICN_BLACK: "tree-line-single-icn-black",
    CAMERA: "camera",
    PDF_ICON: "pdf_icon",
    SKILL_LOW_ICN: 'skill-low-icn',
    SKILL_MEDIUM_ICN: 'skill-medium-icn',
    SKILL_HIGH_ICN: 'skill-high-icn',
    MARK_ICN: 'mark-icn',
    GIFTBOX: 'giftbox',
    CLAIM_SCHOLARSHIP_BANNER: 'claim-banner',
    HOMEWORK_SUCCESS_LEFT: 'homework-success-banner-left',
    HOMEWORK_SUCCESS_RIGHT: 'homework-success-banner-right',
    NOTIFICATION_HEADER_BG: 'notification-header-bg',
    NOTIFICATION_BANNER: 'notification-banner',
    SIGNUP_SUCCESS_BANNER: 'signup-success-banner',
    SUCCESS_GREEN: 'success-green',
    DOWN_CARET_DROPDOWN: 'down-caret-dropdown',
    CW_LOGO: 'cw-logo',
    CW_IMAGE: "cw-image",
    WELCOME: "welcome",
    HEADER_LOGO: 'header-logo',
    USER_PLACEHOLDER: 'user',
    LOGOUT: "logout",
    REMOVE_CIRCLE: 'remove-circle',
    RED_REMOVE: "red-remove",
    FORGOT_PASSWORD: 'forgot-password',
    REPORT_BG_1: 'report-bg1',
    REPORT_BG_2: 'report-bg2',
    HR_LINE: 'line',
    DROPDOWN_ARROW: 'dropdown-arrow',
    LOADER_HEADER: 'loader-header',
    LOADER_FOOTER: 'loader-footer',
    LOADING_GIF: 'loading-gif',
    PRE_LOADER_GIF: 'pre-loader-gif',
    PROFILE_VECTOR: 'profile-vector',
    REPORT_WELCOME_ICON: 'report-welcome-icon',
    EXCEL_ICON: 'excel',
    CLEAR_ICON: 'clear',
    MATHS_DAY_POS: 'maths-days-pos',
    MATHS_DAY_POS_LOGO: 'maths-days-pos-logo',
    SIGNUP_LOGO: 'signup-logo',
    SIGNUP_LOGO_RAMANUJAN: 'signup-logo-ramanujan',
    SIGNUP_LOGO_MATHS_OLYMPIAD: 'signup-logo-maths-olympiad',
    DOWNLOAD_APP_ICON: 'download-app-icn',
    IMD_CLOCK_ICON: 'imd-clock-icn',
    IMD_CALENDAR_ICON: 'imd-calendar-icn',
    GULF_CALENDAR_ICON: "gulf-calendar-icon",
    GULF_CALENDAR_ICON_1: "gulf-calendar-icon-1",
    PRE_ASSESMENT_APP_ICON: 'pre-assesment-app-icn',
    PRE_ASSESMENT_APP_ICON_1: 'pre-assesment-app-icn-1',
    ANDROID_DOWNLOAD: 'android-download',
    IOS_DOWNLOAD: 'ios-android',

    NOTIFICATION_BELL_ACTIVE: 'notification-bell-active',
    DASHBOARD_IN_ACTIVE: 'dashboard-in-active',
    PERFORMANCE_IN_ACTIVE: 'performance-in-active',
    ADMIN_USER: 'admin-user',
    CONTACTS: 'contacts',
    TEACHERS: 'teachers',
    CLASSES: 'classes',
    SETTINGS: 'settings',
    DASHBOARD_ACTIVE: 'dashboard-active',
    PERFORMANCE_ACTIVE: 'performance-active',
    ADMIN_USER_ACTIVE: 'admin-user-active',
    CONTACTS_ACTIVE: 'contacts-active',
    TEACHERS_ACTIVE: 'teachers-active',
    CLASSES_ACTIVE: 'classes-active',
    SETTINGS_ACTIVE: 'settings-active',
    PROFILE_ACTIVE: 'profile_active',
    ONBOARD_TOP_RIGHT: "onboard-top-right",
    ONBOARD_BOTTOM_RIGHT: "onboard-bottom-right",
    CROSS: "cross",
    CROSS_BLACK: "cross_black",
    CHAPTER_ICN: "chapter-icn",
    ADD: "add",
    ADD_BLUE: "add_blue",
    ADD_GRAY: "add_gray",
    EDIT: "edit",
    DELETE: "delete",
    BAR_CHART: 'bar-chart',
    DATA_BAR: 'data_bar',
    CORRECT: "correct",
    NO_RECORDS: 'no-records',
    ENVELOPE: 'envelope',
    MESSAGE: 'message',
    WHATSAPP: 'whatsapp',
    ENVELOPE_WHITE: 'envelope-white',
    MESSAGE_WHITE: 'message-white',
    WHATSAPP_WHITE: 'whatsapp-white',
    BACK_ICON: 'back-icon',
    ACTIVE_TICK: 'active-tick',
    INACTIVE_TICK: 'inactive-tick',
    RECT_TICK: "rect-tick",

    RECT: "rect",
    RECT_BLACK: "rect-black",
    RECT_BLACK1: "rect-black1",

    HOMEWORK_ACTIVE: 'homework-active',
    HOMEWORK_IN_ACTIVE: 'homework-in-active',

    STANDARD_HOMEWORK: 'standard-homework',
    ADAPTIVE_HOMEWORK: 'adaptive-homework',
    RIGHT_ARROW: 'right-arrow',
    COMPLETION_REPORT: 'completion-report',
    HOMEWORK_EVALUATION_REPORT: 'homework-evalution-report',
    MOST_WRONGLY_ANSWERED: 'most-wrongly-answered',
    LEVEL_PROGRESSION_REPORT: 'level-progression-report',
    LEVEL_IMPROVEMENT_REPORT: 'level-improvement-report',
    DOWNLOAD_ICON: 'download-icon',
    DOWNLOAD_ICON_BLUE: 'download-icon-blue',
    EDIT_ICON: 'edit-icon',
    ARCHIVE: 'archive',
    REMAINDER: 'remainder',
    FILTER_SEPERATOR: 'filter-seperartor',
    DELETE_WHITE: "delete-white",
    HAMBARGUR: "hambargur",
    HAMBARGUR1: "hambargur1",
    HAMBARGUR2: "hambargur2",
    INFO: "info",
    INFO1: "info1",
    SEARCH: "search",

    COUNTINGWELL_LOGO: "countingwell-logo",

    HEADER1: "header1",
    PDF: "pdf",
    PDF_WHITE: "pdf-white",
    PRINT: "print",
    DRAG: "drag",
    DRAG_LOADING: "drag-loading",
    REPORT_CARD_INFO: 'report-card-info',
    INFO_CIRCLE: 'info-circle',
    EQUAL_ICON: 'equal-icon',
    UP_ARROW: 'up-arrow',
    DOWN_ARROW: 'down-arrow',
    MATCHING_ARROW: 'matching-arrow',
    DRAG_ICON: 'drag-icon',
    TEST_ACTIVE: 'test-active',
    TEST_INACTIVE: 'test-inactive',
    TEST_RESULTS_ACTIVE: 'test-results-active',
    TEST_RESULTS_INACTIVE: 'test-results-inactive',
    MENU_ICON: 'menu-icon',
    ANSWER_ICON: 'answer-icon',
    SEPARATOR: 'separator',
    CORRECT_ANSWER: 'correct-answer',
    WRONG_ANSWER: 'wrong-answer',
    COMPLETION_REPORT_ACTIVE: 'completion-report-active',
    MOST_WRONGLY_ANSWERED_ACTIVE: 'most-wrongly-answered-active',
    CARD_SEPARATOR: 'card-separator',
    GREEN_TICK: 'green-tick',
    GREEN_TICK_V1: 'green-tick-v1',
    GREEN_TICK_V2: 'green-tick-v2',
    CALENDAR: 'calendar',
    CALENDAR_WHITE: 'calendar-white',
    DOWNLOAD_ACTIVE: 'download-active',
    STUDENTS: 'students',
    EXAM_PAD: 'exam_pad',
    VIDEOS: 'videos',
    QUOTE_LEFT: 'quote_left',
    QUOTE_RIGHT: 'quote_right',
    RIGHT_ARROW_WHITE: 'right_arrow_white',
    RIGHT_ARROW_GRAY: 'right_arrow_gray',
    RIGHT_ARROW_GRAY1: 'right_arrow_gray_1',
    TICK: 'tick',
    TICK_GREEN: 'tick_green',
    TICK_GRAY: 'tick_gray',
    TICK_BLACK: 'tick_black',
    CLASS_SECTION_ICON: 'class_section_icon',
    CLASS_SECTION_ICON_WHITE: 'class_section_icon_white',
    WRONG: 'wrong',
    NO_DATA: 'no_data',
    FILTER: "filter",
    BULB: "BULB",
    RADIO_ACTIVE: "radio_active",
    RADIO_INACTIVE: "radio_inactive",

    GRAPHIC2: "GRAPHIC2",
    GRAPHIC1: "GRAPHIC1",

    STRENGTH_ICN: "strength-icn",
    WEAKNESS_ICN: "weakness-icn",
    SCHOLAR_BLACK: "scholar-black",
    SCHOLAR_WHITE: "scholar-white",
    KNOWLEDGE: "knowledge",
    MODELING: "modeling",
    CALCULATION: "calculation",
    COMPREHENSION: "comprehension",

    

    CLONE_ICON: "clone_icn",
    CLONE_WHITE: "clone_white",
    PENCIL_ICON: "pencil_icn",
    INDIA_MAP_ICON: "india_map_icn",
    INDIA_MAP_PIN: "india_map_pin",
    AD_BANNER: "ad_banner",
    AD_BANNER_1: "ad_banner_1",
    AD_BANNER_3: "ad_banner_3",
    VIDEO_BANNER: "video_banner",
    PEOPLE: "people",
    PLAY_RED: "play_red",
    NOTES: "notes",
    XLS_BLUE: "xls_blue",
    STUDENT_WINNERS_BG: "student_winners_bg",
    FLUENT_CERTIFICATE: "fluent-certificate",
    ARROW_HORIZONTAL: "arrow-horizontal",

    SIGNUP_WEB: "signup-web",
    SIGNUP_MOBILE: "signup-mobile",
    EMAIL: "email",
    SMS: "sms",
    CLONE: "clone",

    INFO_RED: "info-red",
    INFO_GREY: "info-grey",

    DELETE_RED: "delete-red",
    INFO_RED_FILL: "info_red_fill",
    RECT_INACTIVE: "rect-inactive",

    EXTERNAL_LINK: "external_link",
    DIVIDER: "divider",
    HELP_BLUE: "help-blue",

    LOGO_WHITE: "logo-white",
    LOGO_ICON: "logo_icon",

    ELLIPSE: "ellipse",
    ELLIPSE_INACTIVE: "ellipse-inactive",
    ELLIPSE_ACTIVE: "ellipse-active",

    MPL: "mpl",
    FLC: "flc",
    MSF: "msf",
    CURRENCY: "currency",
    REWARD1: "reward1",
    REWARD2: "reward2",
    REWARD3: "reward3",

    FLIPKART: "flipkart",
    AMAZON: "amazon",
    CROMA: "croma",

    USER1: "user1",
    BULLET_LIST: "bullet-list"
}


export const AccessRights = {
    ADD_ADMIN: "ADD_ADMIN",
    EDIT_ADMIN: "EDIT_ADMIN",
    DELETE_ADMIN: "DELETE_ADMIN",
    INVITE_ADMIN: "INVITE_ADMIN",
    ADD_CONTACT: "ADD_CONTACT",
    EDIT_CONTACT: "EDIT_CONTACT",
    DELETE_CONTACT: "DELETE_CONTACT",
    INVITE_CONTACT: "INVITE_CONTACT",
    BULK_UPLOAD_CONTACT: "BULK_UPLOAD_CONTACT",
    ADD_TEACHER: "ADD_TEACHER",
    EDIT_TEACHER: "EDIT_TEACHER",
    DELETE_TEACHER: "DELETE_TEACHER",
    BULK_UPLOAD_TEACHER: "BULK_UPLOAD_TEACHER",
    ADD_CLASS: "ADD_CLASS",
    EDIT_CLASS: "EDIT_CLASS",
    DELETE_CLASS: "DELETE_CLASS",
    DELETE_SECTION: "DELETE_SECTION",
    ADD_STUDENT: "ADD_STUDENT",
    BULK_UPLOAD_STUDENT: "BULK_UPLOAD_STUDENT",
    INVITE_STUDENT: "INVITE_STUDENT",
    EDIT_STUDENT: "EDIT_STUDENT",
    DELETE_STUDENT: "DELETE_STUDENT",
    STANDARD_HOMEWORK_VIEW: "STANDARD_HOMEWORK_VIEW",
    STANDARD_HOMEWORK_CREATE: "STANDARD_HOMEWORK_CREATE",
    STANDARD_HOMEWORK_EDIT: "STANDARD_HOMEWORK_EDIT",
    STANDARD_HOMEWORK_ARCHIVE: "STANDARD_HOMEWORK_ARCHIVE",
    STANDARD_HOMEWORK_REMINDER: "STANDARD_HOMEWORK_REMINDER",
    CLICKER_PRACTICE: 'CLICKER_PRACTICE',

    ADAPTIVE_HOMEWORK_VIEW: "ADAPTIVE_HOMEWORK_VIEW",
    ADAPTIVE_HOMEWORK_CREATE: "ADAPTIVE_HOMEWORK_CREATE",
    ADAPTIVE_HOMEWORK_EDIT: "ADAPTIVE_HOMEWORK_EDIT",
    ADAPTIVE_HOMEWORK_ARCHIVE: "ADAPTIVE_HOMEWORK_ARCHIVE",
    ADAPTIVE_HOMEWORK_REMINDER: "ADAPTIVE_HOMEWORK_REMINDER",

    ADAPTIVE_HOMEWORK_ACTIVE: "ADAPTIVE_HOMEWORK_ACTIVE",
    STANDARD_HOMEWORK_ACTIVE: "STANDARD_HOMEWORK_ACTIVE",
    JIGYASA_ASSIGN_ASSESSMENT: 'JIGYASA_ASSIGN_ASSESSMENT',


    TEST_ARCHIVED: "TEST_ARCHIVE",
    TEST_ACTIVE: "TEST_ACTIVE",
    TEST_REMINDER: "TEST_REMINDER",
    TEST_CREATE: "TEST_CREATE",
    SETUP_SECTION: "SETUP_SECTION"
}

export const StatusText = {
    CORRECT: "Correct",
    IN_CORRECT: "Incorrect",
    NOT_ATTEMPTED: "Not Attempted"
}
